export type ClientTrackingActionType = 'click' ;

export class ClientTrackingActions {
    static readonly Click: ClientTrackingActionType = 'click';
}



// WEBPACK FOOTER //
// ./src/models/ClientTrackingActionType.ts